// extracted by mini-css-extract-plugin
export default {"root":"_np0y","link":"_1MkeI"};